import { render, staticRenderFns } from "./uexccTypeList.vue?vue&type=template&id=f5792050"
import script from "./uexccTypeList.vue?vue&type=script&lang=js"
export * from "./uexccTypeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports